import axios from 'axios'
import { Message, MessageBox, Notification } from 'element-ui'
import {
    getToken,
    removeToken,
    removeUuid,
    removeschoolCode,
    removeroleId,
} from '@/utils/auth'
import router from '../router/index'
import { Loading } from 'element-ui'
// 创建axios实例
let loading//loading的实例对象

let loadingCount = 0;
function start() {

    loading = Loading.service({

        lock: true,

        text: '数据加载中...',
    })
}

function end() {

    loading.close()
}
function showLoaing() {

    if (loadingCount == 0) {

        start();

    }

    loadingCount++

}

function hideLoading() {

    loadingCount--;

    if (loadingCount == 0) {

        end()

    }
}

const service = axios.create({
    baseURL: window.g.BASE_API, // api的base_url
    timeout: 150000 // 请求超时时间
})

let count = 0
// request拦截器
service.interceptors.request.use(config => {
    showLoaing()
    count = 0
    if (getToken()) {
        config.headers['access_token'] = getToken() // 让每个请求携带自定义token 
    }
    return config
}, error => {
    hideLoading()
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {

        hideLoading()
        const res = response.data
        /*   
        SYSTEM_ERROR500(500,"系统内部错误"),
        UNKNOWN_ERROR999(999,"未知错误"),
        PARAM_ERROR(1001,"传入参数错误"),
        PASSWORD_ERROR(1002,"密码错误"),
        DATA_NOTEXIST(2001,"数据已删除或不存在"),
        DATA_SQLERROR(2002,"执行的查询语句为空"),
        DATA_INVALID(2003,"数据无效"),
        DATA_EXIST(2004,"数据已存在"),
        DATA_INSERT_FAIL(2005,"添加失败"),
        DATA_UPDATE_FAIL(2006,"更新失败"),
        DATA_SQLEXECUTEERROR(2007,"执行查询失败"),
        DATA_ACCOUNT_NOTEXIST(2008,"账号不存在"),
        AUTHORIZE_NOLOGON(4011,"账号未登录或登录超时"),
        AUTHORIZE_LOGON(4012,"此账号已在别处登录,是否强制登录"),
        AUTHORIZE_ADMIN(4013,"需要管理员权限"),
        */


        if (res.code === 403) {

            if (count === 0) {
                if (router.currentRoute.path !== '/login') {

                    MessageBox.confirm('登录过期，请重新登录！', '提示', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        // type: 'warning',
                        center: true,
                        showClose: true,
                    }).then(() => {
                        localStorage.removeItem("ButtonPermissions");
                        localStorage.removeItem("routerpath");
                        localStorage.removeItem("roleIds");
                        removeToken();
                        removeUuid();
                        removeschoolCode();
                        removeroleId();
                        router.replace({
                            path: "/login"
                        });

                    }).catch(() => {

                    })
                } else {
                    throw new Error(error);
                }
            }
        }
        count++
        // res.code === 500  res.code === 2004 res.code === 1001 ||
        if ( res.code === 999 || res.code === 2008 || res.code === 4011 || res.code === 4012 || res.code === 3001 || res.code === 3004) {
            Message({
                message: res.msg,
                type: "success",
                center: true,
            });
        } else {
            hideLoading()
            return response.data
        }
    },
    error => {
        router.replace({
            path: "/500"
        });
        // console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 2 * 1000
        // })

        hideLoading()
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js